<template>
	<div class="medical-records">
        <div class="medical-container">
            <div class="patient-info">
                <div class="info-details">
                    <div class="patient-detail">
                        <p class="detail-name">
                            <span class="">{{$t("patient.name")}}：{{infoData.name}}</span>
                            <span class="gender" :class="{'gender-woman':infoData.gender == 2}" ></span>
                            <span class="tag">{{infoData.age}}{{$t("patient.annum")}}</span>
                        </p>
                        <p class="detail-Idcard">
                            <span class="lable">{{$t("patient.IDCard")}}（{{infoData.idType?IdColumns.find(item => infoData.idType == item.value).text:''}}）：</span>
                            <span class="val">
                                {{infoData.idCode}}
                            </span>
                        </p>
                        <p class="detail-Idcard">
                            <span class="lable">{{$t("patient.emergencyTel")}}：</span>
                            <span class="val">
                                {{infoData.emergencyTel||'无'}}
                            </span>
                        </p>
                        <p class="detail-Idcard" v-if="patientStatusTxt">
                            <span class="lable">{{$t("patient.patientStatus")}}：</span>
                            <span class="val">
                                {{patientStatusTxt||'--'}}
                            </span>
                        </p>
                        <p class="detail-Idcard" v-if="infoData.contactTel1">
                            <span class="lable">{{$t("patient.contactTel1")}}：</span>
                            <span class="val">
                                {{infoData.contactTel1||'无'}}
                            </span>
                        </p>
                        <p class="detail-Idcard" v-if="infoData.contactTel2">
                            <span class="lable">{{$t("patient.contactTel2")}}：</span>
                            <span class="val">
                                {{infoData.contactTel2||'无'}}
                            </span>
                        </p>
                    </div>
                    <div class="detail-btn">
                        <span class="btn" @click="gopath">{{$t("patient.editinfobtn")}}</span>
                        <span class="btn" @click="deletePatient">{{$t("patient.unbund")}}</span>
                    </div>
                </div>
            </div>
            <div class="patient-heathly">
                <div class="healthy-title">
                    {{$t("patient.healthyRecord")}}
                </div>
                <div class="healthy-item" v-for="(item,index) in heathlyList" :key="index">
                    <div class="item-left">
                        <div class="time">
                            <p class="yearAndMonth">{{item.yearMonth}}</p>
                            <p class="day">{{item.day}}号</p>
                        </div>
                        <div class="line"></div>
                    </div>
                    <div class="item-right">
                        <template v-if="item.objType != 147012">
                            <div class="tag-operation flexC">
                                <div class="tag-container">
                                    <span class="tag tag2" v-if="item.objType == 147008 && item.traceTag == 0" >{{$t("patient.Visit")}}</span>    
                                    <span class="tag tag4" v-else-if="item.objType == 147008 && item.traceTag != 0" >{{$t("patient.followUpRecord")}}</span>    
                                    <span class="tag tag2"  v-if="item.objType == 147011 && item.pushObjType == 104002">{{$t("patient.article")}}</span>
                                    <span class="tag tag2"  v-if="item.objType == 147011 && item.pushObjType == 104004">{{$t("patient.gauge")}}</span>
                                    <span class="tag tag2" style="padding-left: 1.2rem;"  v-if="item.objType == 147013">{{$t("patient.testIndex")}}</span>                                    
                                </div>
                                <div class="operation-btn flexC" v-if="item.userId == $store.getters.id">
                                    <span class="btn edit" @click="edit(item)">
                                        {{$t("patient.edit")}}
                                    </span>
                                    <span class="btn" @click="deletes(item,index)">
                                        {{$t("patient.deletes")}}
                                    </span>
                                </div>
                            </div>
                            <div class="doctor-info flex" v-if="item.objType != 147013">
                                <img class="pic" :src="item.fromUserFaceUrl" alt="">
                                <span class="info-name">
                                    {{$t("patient.recorder")}}：{{item.fromUserName}}
                                </span>
                            </div>
                            <template v-if="item.objType == 147013">
                                <div class="target-container"  @click="goArticeAndquest(item)">
                                    <div class="project-name flexC">
                                        <span class="label">
                                            {{$t("patient.project")}}：
                                        </span>
                                        <p class="value flexC">
                                            <span >【</span>
                                            <span class="txt">
                                                {{item.question}}
                                            </span>
                                            <span>】</span>
                                            <span class="unusual" v-if="Number(item.quVal) > Number(item.high) || Number(item.quVal) <  Number(item.low)">
                                                异常
                                            </span>
                                        </p>
                                    </div>
                                    <div class="project-name project-value flexC">
                                        <span class="label">
                                            值：{{item.quVal}}
                                        </span>
                                    </div>
                                </div>
                                <div class="articeAndQuestiont-desc ellipse">
                                    {{$t("ratingScale.normaiRange")}}：{{item.low}}~{{item.high}}（{{item.unit}}）
                                </div>
                            </template>
                            <div class="desc" @click="goArticeAndquest(item)">
                                <img src="@/assets/img/healthy-aritce-icon.png" alt="" v-if="item.objType == 147011 && item.pushObjType == 104002">
                                <img src="@/assets/img/healthy-question-icon.png" alt="" v-if="item.objType == 147011 && item.pushObjType == 104004">
                                <div class="txt ellipsisTwo" v-if="item.objType == 147011" v-html="item.pushText"></div>
                                <div class="txt mylog" v-if="item.objType == 147008" :style="'max-height:'+(item.txtOpen?'none;overflow: unset':'1.8rem')+';'">
                                    {{item.traceLog}}
                                    <span class="more-txt"  :class="{'stow':item.txtOpen}"  v-if="item.traceLog&&item.traceLog.length>32" @click="item.txtOpen = !item.txtOpen">{{!item.txtOpen?'全文':'收起'}}</span>
                                </div>
                                <i class="status-icon " v-if="item.objType == 147011" :class="{'status-icon-completed':item.hasOpened > 0||item.hasSubmitted > 0}"></i>
                            </div>

                            <div class="audio-container" v-if="item.traceSounds&&item.traceSounds.length>0">
                                <audio-item :srcUrl="item" v-for="(item,index) in item.traceSounds" :key="index"></audio-item>
                            </div>
                            
                            <div class="info-img" v-if="item.traceMediaItems"  >
                                <template v-for="(citem,cindex) in item.traceMediaItems" >
                                    <div class="img-item" :key="cindex" v-if="index<6" :class="index == 5?'moreImg':''" @click="preViewImage(item,cindex,index)">
                                        <img :src="citem.type == 114001?citem.data.small.url:citem.data.smallImg.url"  alt="">
                                        <img src="@/assets/images/video-play-icon.png" v-if="citem.type == 114003" class="web__msg--video-play" />
                                        <div class="more-over" :key="index+'l'" v-if="index == 5" >
                                            +{{index+1}}
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div class="articeAndQuestiont-desc ellipse" v-if="item.objType == 147011">
                                {{item.pushObjType == 104002?'量表来源':'所属随访'}}：{{item.pushText}}
                            </div>
                        </template>
                        <template v-else>
                            <div class="doctor-info flex">
                                <span class="info-name">
                                    {{$t("patient.status")}}"{{item.userStatus}}"
                                </span>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="mroe-txt" v-if="heathlyList.length>=10" @click="moreData">
                    {{moreType?'～点击加载更多～':'已经到底了～'}}
                </div>
                <div class="list-emtry" v-if="heathlyList.length == 0">
                    <img src="@/assets/img/data-null.png" alt="">
                    <p class="txt">{{$t("patient.heathlyEmtry")}}</p>
                    <div class="btn" @click="add">
                        {{$t("patient.addRecord")}}
                    </div>
                </div>
            </div>
        </div>
        <div class="heathly-btn" v-if="heathlyList.length != 0">
            <div class="btn" @click="add">
                {{$t("patient.addRecord")}}
            </div>
        </div>
        <van-popup v-model="videoShow"  get-container="body" class="videoPopup">
            <img src="@/assets/images/warning.png" class="close" @click="videoShow = false">
            <div  class="video-box" v-if="videoUrl">
                <video  ref="videos" id="video" v-if="videoShow"  controls="controls" @focus="clickVideo($event)" :poster="videoPoster">
                    <source :src="videoUrl" type="video/mp4">
                    <!-- <source :src="msgWrapper.msg.msgBody.content.url" type="video/webm">
                    <source :src="msgWrapper.msg.msgBody.content.url" type="video/ogg"> -->
                    {{$t('im.noVideo')}}
                </video>
            </div>
        </van-popup>
	</div>
</template>

<script>
import { ImagePreview } from 'vant'
import audioItem from "./audio-item.vue"
import { patientDelete } from "@/api/patient";
import { getPatientInfo, tracehealthyQuery, hospAdd,  tracehealthyDel, patientStatusGet} from "@/api/patient"
import { getLocalMinutesTime } from "@/utils/date";
import imageData from "./imageData.vue"
import { IdColumns } from "@/utils/staticData"
import { Inhospitalquery } from "@/api/index";

export default {
	components:{ imageData, audioItem },
	data(){
		return{
			infoData:{},
			subscribeType:false,
			patientId:this.$route.query.patientId,
			getLocalMinutesTime,
            heathlyList:[],
			IdColumns,
			yuyueZhuyuanId:"",
            pageNum:1,
            moreType:true,
            videoShow:false,
            videoUrl:"",
            videoPoster:"",
            patientStatusTxt:""
		}
	},
	created(){
		document.title = this.$t("patient.patientDetails")
		this.getPatientData();
        this.gethealthyRecord();
		this.getsubscribe();
	},
	methods:{
        add(){
            this.$router.push({
                path:"/patient/addHeathly",
                query:{
                    patientId:this.patientId
                }
            })
        },
        goArticeAndquest(item){
            if(item.objType == 147011 || item.objType == 147013){
                let query = item.objUrl.split("?")[1].split("&")
                let obj = {};
                for (let i = 0; i < query.length; i++) {
                    const it = query[i].split("=");
                    obj[it[0]] = it[1];
                }
                if(item.pushObjType == 104002){
                    this.$router.push({
                        path:"/article/detail",
                        query:obj
                    })
                }else if(item.pushObjType == 104004){
                    this.$router.push({
                        path:"/questionaire/go-questionaire",
                        query:obj
                    })
                }else if(item.objType == 147013){
                    this.$router.push({
                        path:"/questionaire/go-questionaire",
                        query:obj
                    })
                }
            }
        },
        moreData(){
            if(this.moreType){
                this.pageNum++;
                this.gethealthyRecord();
            }
        },
        edit(item){
            this.$router.push({
                path:"/patient/addHeathly",
                query:{
                    patientId:this.patientId,
                    heathlyId:item.objId
                }
            })
        },
        preViewImage(item,index,findex){
            console.log(item,index,findex);
            if(item.traceMediaItems[index].type == 114001){
                if(!item.perImageUrls){
                    let ImgArr = [];
                    for (let i = 0; i < item.traceMediaItems.length; i++) {
                        const jt = item.traceMediaItems[i];
                        if(jt.type == 114001){
                            ImgArr.push(jt.data.big.url);
                        }
                    }
                    this.heathlyList[findex].perImageUrls = ImgArr;
                }
                let viewIndex = this.heathlyList[findex].perImageUrls.findIndex(it => it == item.traceMediaItems[index].data.big.url);
                // traceMediaItems
                console.log(item);
                ImagePreview({
                    images: this.heathlyList[findex].perImageUrls,
                    startPosition: viewIndex,
                });
            }else {
                this.videoUrl = item.traceMediaItems[index].data.url;
                this.videoPoster = item.traceMediaItems[index].data.bigImg.url;
                this.videoShow = true;
                setTimeout(()=>{
                    // console.log(this.$refs.video);
                    this.$refs.videos.play();
                    // window.scrollBy(0,1);
                    // window.location.href = this.msgWrapper.msg.msgBody.content.url
                },500)
            }
        },
        deletes(item,index){
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            tracehealthyDel({
                id:item.objId
            }).then(result =>{
                toast.clear();
                if(result){
                    if(result.data.errorCode == 0){
                        this.heathlyList.splice(index,1)
                    }
                }
            })
        },
		deletePatient(){
			let that = this;
			this.$dialog.confirm({
				title: that.$t("patient.confirmtitle"),
				message: that.$t("patient.confirmMessage",{name:that.infoData.name}),
				confirmButtonText:that.$t("patient.confirmButtonText"),
				confirmButtonColor:"#F56C6C",
				className:"unbindconfrim"
			})
			.then(() => {
				const toast = this.$Toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: that.$t("message.loadingTxt")
				});
				patientDelete({id:that.$route.query.patientId}).then(res=>{
					toast.close()
					 if(res.data.errorCode == 0){
						that.$Toast(that.$t("comonTxt.operationsuccess"))
						that.$router.go(-1)
					}else{
						that.$Toast(that.$t("comonTxt.operationfail"))
					}
				})
				// on confirm
			}).catch(()=>{

			})
        },
        gethealthyRecord(){
            tracehealthyQuery({
                userId:this.patientId,
                pageNum:this.pageNum,
                pageSize:10
            }).then(result =>{
                if(result.data.errorCode == 0){
                    for (let i = 0; i < result.data.data.data.length; i++) {
                        const it = result.data.data.data[i];
                        it.yearMonth = new Date(it.cdt).getFullYear()+'/'+(new Date(it.cdt).getMonth()+1);
                        it.day = new Date(it.cdt).getDate();
                        it.txtOpen = false;
                        if(it.traceMediaItems&&it.traceMediaItems.length!=0){
                            it.imagUrl = [];
                            for (let j = 0; j < it.traceMediaItems.length; j++) {
                                const jt = it.traceMediaItems[j];
                                jt.data = JSON.parse(jt.data);
                            }
                        }
                    }
                    if(this.pageNum == 1){
                        this.heathlyList = result.data.data.data;
                    }else{
                        if(result.data.data.data.length<10){
                            this.moreType = false;
                        }
                        for (let j = 0; j < result.data.data.data.length; j++) {
                            const jt = result.data.data.data[j];
                            this.heathlyList.push(jt)
                        }
                    }
                    console.log(this.heathlyList);
                }
            })
        },
		seeImsge(){
			this.$router.push({
				path:"/patient/imageData",
				query:{
					patientId:this.patientId
				}
			})
		},
		getsubscribe(){
			Inhospitalquery({
				patientId:this.$route.query.patientId
			}).then(res => {
				if(res.data.data&&res.data.data.length!=0){
					this.subscribeType = true;
					this.yuyueZhuyuanId = res.data.data[0].yuyueZhuyuanId
				}
			})
		},
		handleHosp(){
			const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
			hospAdd({
				patientId:this.patientId
			}).then(res=>{
				toast.clear();
				if(res.data.errorCode == 0){
					this.hospType = true;
				}else{
					this.$toast(res.data.errorMsg)
				}
			})
		},
		handleGoList(){
			this.$router.push({
				path:"/admission/index"
			})
		},
		Indevelop(){
			this.$router.push({
				path:"/subscribeHospital/index",
			})
		},
		// 查看就诊详情
		goDetail(item){
			this.$router.push({
				path:"/patient/medicalRecordsDetails",
				query:{
					medicalId:item.id
				},
			})
		},
	
		getPatientData(){
			const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            getPatientInfo({id:this.$route.query.patientId}).then(res=>{
                toast.close();
                this.infoData = res.data.data.user;
            })
            patientStatusGet({id:this.$route.query.patientId}).then(res =>{
                console.log(res);
                if(res.data.errorCode == 0 && res.data.data){
                    this.patientStatusTxt = res.data.data.status;
                }
            })
		},
		gopath(){
			this.$router.push({
                path:"/patient/edit",
                query:{
                    patientId:this.$route.query.patientId
                }
            })
		}
	}
}
</script>

<style lang="scss" >

.medical-records{
  	height: 100%;
	background: #F5F6F9;
    display: flex;
    flex-direction: column;
	box-sizing: border-box;
	
	.patient-info{
        flex: 0 0 auto;
		border-radius: 0.4rem;
		background: linear-gradient(0deg, #569CFF 0%, #DBEEFC 100%);
		box-shadow: 0 0.12rem 0.3rem 0 rgba(203, 219, 235, 0.25);
		border-radius: 0.4rem;
		padding: 0.4rem;
		margin: 0.4rem 0;
		.info-details{
			padding: 0.6rem;
			border-radius: 0.32rem;
			background: #fff;
			.patient-detail{
				margin-bottom: 0.3rem;
				.detail-name{
					margin-bottom: 0.3rem;
					display: flex;
					align-items: center;
					font-size: 0.64rem;
					font-family: PingFang SC;
					font-weight: 400;
					color: #333333;
					.gender{
						width: 0.7rem;
						height: 0.7rem;
						margin: 0 0.3rem;
						background: url("~@/assets/img/patient-gender-man.png") no-repeat;
						background-size: 100% 100%;
					}
					.gender-woman{
						background-image: url("~@/assets/img/patient-gender-woman.png") no-repeat;
					}
					.tag{
						font-size: 0.52rem;
						font-family: PingFang SC;
						font-weight: 400;
						color: #666666;
						padding: 0.1rem 0.3rem;
						border: 0.02rem solid #666666;
						border-radius: 0.4rem;
					}
				}
				.detail-Idcard{
					margin-bottom: 0.3rem;
					font-size: 0.52rem;
					font-family: PingFang SC;
					font-weight: 400;
					color: #666666;
					display: flex;
					align-items: flex-start;
					.lable{
						flex: 0 0 auto
					}
					.val{
						flex: 1;
						word-break:break-all
					}
				}
			}
			.detail-btn{
				font-size: 0.52rem;
				font-family: PingFang SC;
				font-weight: 500;
				color: #49A7FF;
				.btn{
					margin-right: 1.2rem;
				}
			}
		}
		.hosp-box{
			margin: 0.52rem 0;
			.box-btn{
				flex: 1;
				height: 1.72rem;
				width: 304px;
				border: 0.04rem solid #FFFFFF;
				color: #fff;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 0.32rem;
				font-size: 0.64rem;
				font-family: PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				&:last-child{
					margin-left: 0.6rem;
				}
				img{
					height: 0.54rem;
					width: auto;
					margin-right: 0.2rem;
				}
				.subscribe-box{
					position: relative;
					
				}
				.hand{
					&::after{
						// content: ' ';
						// top: -0.31rem;
						// right: -0.4rem;
						// position: absolute;
						// display: block;
						// width: 0;
						// height: 0;
						// border-color: transparent;
						// border-style: solid;
						// border-width: 0.3rem;
						// border-left-width: 0;
						// border-right-color: #FFC00F;
						// transform: rotate(180deg);
					}
					span{
						position: absolute;
						font-size: 0.4rem;
						border-radius: 0.15rem;
						width: max-content;
						padding: 0.08rem 0.1rem;
						background: #FFC00F;
						top: -0.6rem;
						right: -1.51rem;
						z-index: 99;
					}
				}
				
			}
			.btnhandle{
				background: #D1E8FC;
				color: #49A7FF;
			}
		}
	}
    .patient-heathly{
        flex: 1;
        .healthy-title{
            margin: 0.6rem 0;
            padding-left: 0.6rem;
            font-size: 0.72rem;
            font-weight: 500;
            font-weight: 600;
            color: #333333;
            line-height: 1rem;
            position: relative;
            &::after{
                width: 0.2rem;
                height: 0.72rem;
                background: #49A7FF;
                border-radius: 0.1rem;
                position: absolute;
                content: ' ';
                left: 0;
                top: 50%;
                transform: translate(0,-50%); 
            }
        }
        .healthy-item{
            margin-bottom: 0.6rem;
            display: flex;
            .item-left{
                flex: 0 0 auto;
                display: flex;
                flex-direction: column;
                align-items: center;
                // justify-content: center;
                .line{
                    flex: 1;
                    // width: 0.04rem;
                    margin-left: -1rem;
                    border: 0.03rem solid #BFBFBF;
                }
                .time{
                    flex: 0 0 auto;
                    margin-bottom: 0.3rem;
                    .yearAndMonth{
                        font-size: 0.48rem;
                        font-family: Helvetica;
                        color: #666666;
                        line-height: 0.6rem;
                    }
                    .day{
                        font-size: 0.72rem;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                        line-height: 1rem;
                    }
                }
            }
            .item-right{
                margin-left: 0.3rem;
                flex: 1;
                background: #FFFFFF;
                padding: 0.6rem;
                border-radius: 0.32rem;
                overflow: hidden;
                .tag-operation{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    overflow: hidden;
                    margin-right: 0.2rem;
                    flex: 1;
                    .tag-container{
                        .tag{
                            display: inline-block;
                            font-size: 0.48rem;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #FFFFFF;
                            line-height: 0.66rem;
                            padding: 0.2rem 0.4rem 0.2rem 0.8rem;
                            margin-right: 0.6rem;
                        }
                        .tag2{
                            background: url("~@/assets/img/healthy-tag-back.png") no-repeat;
                            background-size: 100% 100%;
                        }
                        .tag4{
                            background: url("~@/assets/img/healthy-tag-back2.png") no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                }
                .doctor-info{
                    align-items: center;
                    margin: 0.1rem 0;
                    .pic{
                        width: 0.8rem;
                        height: 0.8rem;
                        border-radius: 50%;
                    }
                    .info-name{
                        font-size: 0.64rem;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 0.9rem;
                        margin: 0 0.3rem;
                    }
                }
                .desc{
                    display: flex;
                    align-items: flex-start;
                    margin: 0.4rem 0 0.2rem 0;
                    position: relative;
                    .status-icon{
                        width: 1.84rem;
                        height: 1.84rem;
                        background: url("~@/assets/img/healthy-status-icon.png") no-repeat;
                        background-size: 100% 100%;
                        position: absolute;
                        right: 0;
                        top: -50%;
                    }
                    .status-icon-completed{
                        background: url("~@/assets/img/healthy-status-icon2.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    img{
                        width: 2rem;
                        height: 2rem;
                        flex: 0 0 auto;
                        margin-right: 0.4rem;
                    }
                    .txt{
                        flex: 1;
                        font-size: 0.64rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 0.9rem;
                    }
                    .mylog{
                        max-height: 1.8rem;
                        overflow: hidden;
                        position: relative;
                        transition:  all 2s;
                        .more-txt{
                            position: absolute;
                            bottom: -0.1rem;
                            right: 0;
                            background: #fff;
                            font-size: 0.52rem;
                            padding: 0.06rem 0.1rem;
                            border-radius: 0.04rem;
                            color: #49A7FF;
                        }
                        .stow{
                            // transform: translate(0, 80%);
                            width: 100%;
                            position: unset;
                            text-align: center;
                            display: block;
                        }
                    }
                }
                .target-container{
                    .project-name{
                        font-size: 0.64rem;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 0.9rem;
                        .label{
                            flex: 0 0 auto;
                        }
                        .value{
                            overflow: hidden;
                            flex: 1;
                            .txt{
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                color: #499FFF;
                            }
                            .unusual{
                                flex: 0 0 auto;
                                background: url("~@/assets/img/ratingScale-value-status-icon2.png") no-repeat;
                                background-size: 0.6rem 0.54rem;
                                background-position: left;
                                padding-left: 0.7rem;
                                font-size: 0.5rem;
                                color: #F56C6C;
                            }
                        }
                    }
                    .project-value{
                        margin-bottom: 0.2rem;
                    }
                }
                .audio-container {
                    
                }
                .info-img{
                    display: flex;
                    flex-wrap: wrap;
                    // // grid-template-rows: repeat(3, 1fr);
                    // grid-template-columns: repeat(3, 1fr);
                    // // grid-template-columns: 1fr 1fr 1fr;

                    // grid-gap: 0.2rem;
                    .img-item{
                        width: 3.2rem;
                        height: 3.2rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 0.24rem;
                        overflow: hidden;
                        margin-right: 0.2rem;
                        position: relative;
                        margin-top: 0.2rem;
                        box-shadow: 0 0.02rem 0.06rem 0.04rem rgba(0, 0, 0, 0.2);
                        &:nth-child(3n){
                            margin-right: 0;
                        }
                        img{
                            max-width: 100%;
                            max-height: 100%;
                            height: auto;
                            width: auto;
                        }
                        .web__msg--video-play{
                            width: 0.86rem;
                            height: 0.86rem;
                            top: 0;
                            left: 0;
                            bottom: 0;
                            right: 0;
                            margin: auto;
                            background-size: cover;
                            position: absolute;
                        }
                    }
                }
                .articeAndQuestiont-desc {
                    padding: 0.24rem 0.4rem;
                    background: #ECF5FF;
                    border-radius: 0.08rem;
                    font-size: 0.52rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #606266;
                }
                .moreImg{
                    position: relative;
                    .more-over{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        background: rgba(0, 0, 0, 0.4);
                        font-size: 1.04rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #FFFFFF;
                    }
                }
                .operation-btn{
                    flex: 0 0 auto;
                    .btn{
                        font-size: 0.52rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #49A7FF;
                        padding: 0 0.2rem;
                        border-right: 0.02rem solid #49A7FF;
                        &:last-child{
                            border-right: 0;
                        }
                    }
                    .edit{
                        padding-left: 0.7rem;
                        position: relative;
                        &::after{
                            top: 50%;
                            transform: translate(0,-50%);
                            content: ' ';
                            position: absolute;
                            width: 0.5rem;
                            left: 0;
                            height: 0.5rem;
                            background: url("~@/assets/img/edit-icon.png") no-repeat;
                            background-size: 100% 100%;
                        }
                    }
                }
            }
        }
        .mroe-txt{
            font-size: .48rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 0.7rem;
            text-align: center;
            margin: 0.6rem;
        }
        .list-emtry{
            height: 50vh;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            img{
                width: 6.4rem;
                height: auto;
            }
            .txt{
                font-size: 0.6rem;
                color: #C0C4CC;
            }
            .btn{
                width: 11.4rem;
                height: 1.6rem;
                background: linear-gradient(180deg, #49C1FF 0%, #499FFF 100%);
                border-radius: 0.8rem;
                line-height: 1.6rem;
                text-align: center;
                font-size: 0.6rem;
                color: #fff;
                margin-top: 1rem;
            }
        }
    }
    .medical-container{
	    padding:  0 0.6rem;
        flex: 1;
        overflow: auto;
    }
	.heathly-btn{
        padding: 0.6rem 1rem;
        background: #FFFFFF;
        flex: 0 0 auto;
        .btn{
            height: 1.68rem;
            font-size: 0.72rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 1.68rem;
            text-align: center;
            background: linear-gradient(180deg, #49C1FF 0%, #499FFF 100%);
            border-radius: 0.84rem;
        }
    }
}

</style>
<style lang="scss">
.list-empty{
	height: 6rem;
	// background: #fff;
	margin-top: 0.6rem;
	border-radius: 0.4rem;
	display: flex;
	justify-content: center;
	align-items: center;
	img{
		height: 4rem;
	}
}
 .unbindconfrim{
	 width: 70%;
	 .van-dialog__message {
		font-size: 0.64rem;
		color: #333333;
		height: auto;
		line-height: unset;
		padding-top: 0.4rem;
	}
	.van-dialog__header{
		font-weight: 600;
		font-size: 0.7rem;
	}
	.van-dialog__cancel, .van-dialog__confirm{
		height: 1.8rem;
	}
	.van-button__text{
		font-size: 0.7rem;
	}
}
.videoPopup{
  width: 90%;
  height: 95%;
  margin: 0 auto;
  background: none;
  img{
    width: 1.25rem;
    height: 1.25rem;
    right: 0;
    top: 0;
    z-index: 9;
    position: absolute;
  }
  .video-box{
    width: 100%;
    height: 100%;
    // margin-top: 1.5rem;
    video{
      height: 100%;
      width: 100%;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>